module.exports = "<p>\r\n  echexbase works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/echexbase/echexbase.component.html
// module id = ../../../../../src/app/echexbase/echexbase.component.html
// module chunks = main